import { useEffect } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import { Button } from "@/shared/ui";
import { FACE, FACE_KEYS } from "@/domains/createCharacter/constants/face";
import { faceSelector, nextStep, prevStep, setCorrectStep } from "@/domains/createCharacter/slice";
import useChangeFace from "@/domains/createCharacter/hooks/useChangeFace";
import CreateCharacterArrowSwitcher from "@/domains/createCharacter/components/CreateCharacterArrowSwitcher";
import CreateCharacterRange from "@/domains/createCharacter/components/CreateCharacterRange";
import CreateCharacterScrollArea from "@/domains/createCharacter/components/CreateCharacterScrollArea";
import CreateCharacterStepHeader from "@/domains/createCharacter/components/CreateCharacterStepHeader";

const eyeColorVariants = new Array(32).fill(0).map((_, i) => i);

export default function CreateCharacterFaceContainer() {
  const dispatch = useAppDispatch();
  const face = useAppSelector(faceSelector);
  const { eyeColor, onChangeEyeColor, onChangeFaceFeature, randomizeAll } = useChangeFace();

  useEffect(() => {
    dispatch(setCorrectStep({ step: 2, isCorrect: true }));
  }, [dispatch]);

  return (
    <>
      <CreateCharacterStepHeader title="Внешность" onRandom={randomizeAll} />
      <CreateCharacterScrollArea>
        <CreateCharacterArrowSwitcher
          label="Цвет глаз"
          value={eyeColor}
          variants={eyeColorVariants}
          onChange={onChangeEyeColor}
        />
        {FACE_KEYS.map((feature) => (
          <CreateCharacterRange
            min={-1}
            key={feature}
            label={FACE[feature].localization}
            value={face[feature]}
            hasRandom
            onChange={(value) => {
              onChangeFaceFeature(feature, value);
            }}
          />
        ))}
      </CreateCharacterScrollArea>
      <div className="grid grid-cols-2 items-center gap-2.5 pt-2 mt-auto">
        <Button variant="solid-surface-gradient" onClick={() => dispatch(prevStep())}>
          Назад
        </Button>
        <Button onClick={() => dispatch(nextStep())}>Далее</Button>
      </div>
    </>
  );
}
